<div #tutorialGraphComponent class="graph-component"></div>
